import { createContext, useContext, ReactNode } from 'react';
import { useNavigate } from 'react-router-dom';

type SearchModalContextType = {
  openSearch: () => void;
  closeSearch: () => void;
};

export const SearchModalContext = createContext<SearchModalContextType | undefined>(undefined);

export const useSearchModal = () => {
  const context = useContext(SearchModalContext);
  if (!context) {
    throw new Error('useSearchModal must be used within SearchModalProvider');
  }
  return context;
};

export const SearchModalProvider = ({ children }: { children: ReactNode }) => {
  const navigate = useNavigate();

  const openSearch = () => navigate('/?openSearch=true');
  const closeSearch = () => {};

  return (
    <SearchModalContext.Provider value={{ openSearch, closeSearch }}>
      {children}
    </SearchModalContext.Provider>
  );
};
